import React from 'react'
import Brazil from '../assets/brazil.png'

const Footer = ({ children }) => {
    return (
        <div className='p-4 pt-5 bg-gray-300 sm:flex justify-between items-center font-ronsof-four color-ronsof-one'>
            <div>
                <p className='mx-5'>
                    Ronsof iT
                </p>
                <p className='mx-5'>
                    CNPJ: 36.701.770./0001-09
                </p>
                <p className='mx-5'>
                    ronsof.it@gmail.com
                </p>
                <p className='mx-5'>
                    ronsof.com
                </p>
                <p className='mx-5'>
                    São Paulo - Brazil
                </p>
                <a href='https://www.ronsof.com'>
                    <p className='mx-5 pt-5'>| © 2020 Ronsof iT | Terms of Use | Privacy Policy |</p>
                </a>
            </div>

            <div>
                <a href='https://www.ronsof.com'>
                    <p className='mx-5'>
                        An Ronsof iT product
                        <img className='w-5 mx-20 animation-ronsof-one' src={Brazil} alt='Brazil' />
                    </p>
                    
                </a>
                
                
            </div>
            {children}
        </div>
    )
}
export default Footer